<template>
  <div class="mt-4">
    <div class="h5 font-weight-semibold mb-2 mt-2" style="font-weight: bold">Kết quả kiểm tra</div>

    <div class="table-responsive p-3">
      <table class="table table-bordered table-striped" style="min-width: 800px;">
        <thead class="thead-light sticky-top">
        <tr>
          <th v-for="header in tableHeaders" :key="header.key">
            {{ header.label }}
          </th>
          <th>Hành động</th>
        </tr>
        </thead>

        <tbody >
        <tr v-if="!tests.length">
          <td colspan="11"  style="text-align: center">
            Không có dữ liệu
          </td>
        </tr>
        <tr
          v-else
          v-for="(test, idx) in tests"
          :key="idx"
        >
          <td v-for="header in tableHeaders" :key="header.key">
            <template v-if="header.key === 'result_new' && test.type === 'Thi đầu khóa'">
              {{ test.recommended_course_name }}
            </template>
            <template v-else-if="header.key === 'result_new'">
              <el-tooltip
                v-if="isFailResult(test[header.key]) && getFailReasons(test.fail_reasons).length"
                effect="dark"
                placement="top"
              >
                <div slot="content">
                  <span style="font-weight: 700">Nguyên nhân fail khóa:</span>
                  <div style="width: 100%; height: 1px; background: white; margin: 8px 0"></div>
                  <ul class="mb-0">
                    <li style="list-style: none; display: flex; align-items: center" v-for="(reason, reasonIndex) in getFailReasons(test.fail_reasons)" :key="reasonIndex">
                      <div style="width:5px; height: 5px; border-radius: 9999px; background: red; margin-right: 5px"></div>
                      <span>{{ reason }}</span>
                    </li>
                  </ul>
                </div>
                <div class="d-inline-block">
                  <span :class="getResultObj(test[header.key]).class">
                    {{ getResultObj(test[header.key]).text }}
                  </span>
                </div>
              </el-tooltip>
              <span
                v-else-if="test[header.key] !== '-'"
                :class="getResultObj(test[header.key]).class"
              >
                {{ getResultObj(test[header.key]).text }}
              </span>
              <span
                  v-else
                  :class="getResultObj(test[header.key]).class"
              >
                  {{ getResultObj(test[header.key]).text }}
                </span>
            </template>
            <template v-else>
              {{ test[header.key] }}
            </template>
          </td>

          <td>
            <button
              v-if="test.type == 'Test đầu vào'"
              @click="openReportCard(test.uuid, test.center_id)"
              class="btn btn-sm btn-outline-primary"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Phiếu điểm"
            >
              <i class="el-icon-notebook-2"></i>
            </button>
            <button
              v-if="test.type !== 'Test đầu vào' && test.type !== 'Thi đầu khóa'"
              @click="detailTest(test)"
              class="btn btn-sm btn-outline-primary"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Chi tiết kiểm tra"
            >
              <i class="fa fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Bootstrap -->
    <el-dialog :title="`Lịch sử kiểm tra: ` + student_name + ` - ` + currentTest.type" :visible.sync="outerVisible">
      <div v-if="loading" class="text-center py-4">Đang tải dữ liệu...</div>
      <div v-else>
        <TestHistory :testHistoryData="testHistoryData" :test="currentTest"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TestHistory from "./TestHistory";
import moment from 'moment'
import {DETAIL_TEST_STUDENT} from "@/core/services/store/customer/customer-crm.module";

export default {
  name: 'TestResult',
  components: { TestHistory },

  props: {
    tests: {
      type: Array,
      required: true
    },
    student_name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      outerVisible: false,
      testHistoryData: [],
      currentTest: {},
      tableHeaders: [
        { label: 'Ngày kiểm tra', key: 'date_exam' },
        { label: 'Buổi kiểm tra', key: 'type' },
        { label: 'Kết quả', key: 'result_new' },
        { label: 'Overall', key: 'overall' },
        { label: 'Listening', key: 'listening' },
        { label: 'Speaking', key: 'speaking' },
        { label: 'Reading', key: 'reading' },
        { label: 'Writing', key: 'writing' },
        { label: 'Vocab', key: 'vocabulary' },
        { label: 'Reading & Writing', key: 'reading_and_writing' }
      ]
    }
  },

  mounted() {
    // Kích hoạt tooltip Bootstrap
  },

  methods: {
    isFailResult(result) {
      return result === 0 || String(result).trim().toLowerCase() === 'fail'
    },

    getFailReasons(failReasons) {
      if (Array.isArray(failReasons)) {
        return failReasons.filter(reason => reason != null && String(reason).trim())
      }

      if (typeof failReasons !== 'string' || !failReasons.trim()) {
        return []
      }

      try {
        const parsedReasons = JSON.parse(failReasons)
        return Array.isArray(parsedReasons) ? parsedReasons : [failReasons]
      } catch (e) {
        return [failReasons]
      }
    },

    getResultObj(result) {
      if (result === 1 || result === 'Pass') {
        return {
          text: 'Pass',
          class: 'badge bg-green px-3 py-2'
        }
      }
      if (result === 0 || result === 'Fail') {
        return {
          text: 'Fail',
          class: 'badge badge-fail px-3 py-2'
        }
      }
      return { text: result || '-', class: 'badge badge-secondary px-3 py-2' }
    },

    transformTestHistoryData(rawData) {
      return (rawData || []).map((item, index) => {
        const testMark = item.test_mark || {}
        return {
          attempt: `Lần ${item.order || index + 1}`,
          result: item.mark_result ? (item.mark_result === 'Pass' ? 'Pass' : 'Fail') : '-',
          overall: item.avg_score != null ? parseFloat(item.avg_score).toFixed(1) : '-',
          listening: testMark.listening_score || '-',
          speaking: testMark.speaking_score || '-',
          reading: testMark.reading_score || '-',
          writing: testMark.writing_score || '-',
          vocab: testMark.vocabulary_score || '-',
          reading_writing: testMark.reading_and_writing_score || '-',
          updated_at: item.updated_at ? moment(item.updated_at).format('DD/MM/YYYY') : '-',
          order: item.order,
          lesson: item.lesson,
          check_mark_exam: item.check_mark_exam,
        }
      })
    },

    async detailTest(test) {
      this.outerVisible = true;
      this.currentTest = test
      this.loading = true
      this.testHistoryData = []
      try {
        this.$store.dispatch(DETAIL_TEST_STUDENT, {
          student_id: this.$route.params.id,
          list_test_id: test.list_test_id
        }).then((res) => {
          if (res && res.data && res.data.length) {
            console.log(res, 'a')
            this.testHistoryData = this.transformTestHistoryData(res.data)
          }
        });
      } catch (e) {
        console.error('Error fetching test history:', e)
      } finally {
        this.loading = false
      }
    },
    openReportCard(uuid, center_id)
    {
      let url = '';
      switch (center_id) {
        case 516:
          url = 'https://testinput.ieltsmentor.edu.vn/login?token=' + uuid;
          break;
        case 295:
          url = 'https://testinput.ecoach.vn/login?token=' + uuid;
          break;
      }
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 10;
}

.badge {
  min-width: 56px;
  font-size: 0.85rem;
}
.bg-green {
  background: #128300;
  color: white;
}

.badge-fail {
  background: #6366F1;
  color: white;
}
</style>
